// @flow
export type ChangeCarouselSlotIndex = {
  type: 'CHANGE_CAROUSEL_SLOT_INDEX',
  payload: {
    pinId: string,
    index: number,
  },
};

export default function changeCarouselSlotIndex(
  pinId: string,
  index: number,
): ChangeCarouselSlotIndex {
  return {
    type: 'CHANGE_CAROUSEL_SLOT_INDEX',
    payload: {
      pinId,
      index,
    },
  };
}
